﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';


import tpl_searchEvent from './tpl/searchEvent.html';

import View_SearchEventList from './searchEventList';
import View_SearchEventQuery from './searchEventQuery';
import View_Pagination from '../../../lib/views/pagination/pagination';
import View_InformationNoHeader from '../../../lib/views/informationNoHeader/informationNoHeader';
import * as Entities_Empty from '../../../lib/entities/empty';

export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_searchEvent();
    },
    initialize: function () {
        //this.modal_waitingModal = new app.models.WaitingModal();
        //this.modal_waitingModal.attributes.Title = resources.X100027;
        //this.modal_waitingModal.attributes.Text = resources.X100030;
        //this.modal_waitingModal.attributes.Button = resources.X100279;

        this.app = this.options.app;
        this.informationCollection = new Entities_Empty.Collection();
    },
    childEvents: {
        'rerender': function (childView, msg) {
            this.searchEventPagination.currentView.render();
            this.updateInformationCollection();
        },
        //'waiting_show': function (childView, msg) {
        //    this.waiting.currentView.waiting_show();
        //},
        //'waiting_hide': function (childView, msg) {
        //    this.waiting.currentView.waiting_hide();
        //}
    },
    regions: {
        searchEventQuery: "#searchEventQuery",
        searchEventList: "#searchEventList",
        searchEventPagination: "#searchEventPagination",
        information: "#searchEventInformation"
        //waiting: "#waitingModal"
    },
    onBeforeShow: function () {
        this.searchEventList.show(new View_SearchEventList({ collection: this.collection, app : this.app }));
        this.searchEventQuery.show(new View_SearchEventQuery({ collection: this.collection, app : this.app }));
        this.searchEventPagination.show(new View_Pagination({ collection: this.collection, app : this.app }));
        this.information.show(new View_InformationNoHeader({ collection: this.informationCollection, app : this.app, enableHeader : false }));
        //this.waiting.show(new app.views.Waiting_modal({ model: this.modal_waitingModal }));
                
    },
    renderInformation: function () {
        this.informationCollection.reset();

        //No customYet yet
        if (this.collection.length <= 0) {
            var tmpModel = new this.informationCollection.model({ Information: resources.X100976 });
            this.informationCollection.add(tmpModel);
        }
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
});